import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import Icon from 'react-fa';

export const EmailCell = ({ cellData }) => {
  const parts = cellData.split('@');
  let rest = null;
  if (parts.length > 0) {
    rest = <span className='emailDomain'>@{parts.slice(1).join('@')}</span>;
  }
  return (<span>
    {parts[0]}{rest}
  </span>);
};

EmailCell.propTypes = {
  cellData: PropTypes.string,
};


export const DateCell = ({ cellData }) => {
  if (cellData) {
    const dateText = cellData.format('D MMM, h:mm A');
    const year = cellData.year();
    return (<span>{dateText} <span className='year'>({year})</span></span>);
  }
  return null;
};

DateCell.propTypes = {
  cellData: PropTypes.instanceOf(moment),
};


export const StatusCell = ({ cellData }) => {
  const cn = classNames({
    label: true,
    'label-danger': (cellData === 'failed' || cellData === 'killed'),
    'label-success': (cellData === 'done' || cellData === 'finished' || cellData === 'loaded'),
    'label-default': (cellData !== 'failed' && cellData !== 'done'
      && cellData !== 'killed' && cellData !== 'finished' && cellData !== 'loaded'),
  });
  return (
    <span className={cn}>{cellData}</span>
  );
};

StatusCell.propTypes = {
  cellData: PropTypes.string,
};

// helpers to parse scenarios
const iconSet = {
  unknown: { icon: 'spinner', text: 'Requested', class: 'muted' },
  requested: { icon: 'spinner', text: 'Requested', class: 'muted' },
  starting: { icon: 'spinner', text: 'Starting', class: 'fa-spin muted' },
  launching: { icon: 'spinner', text: 'Launching', class: 'fa-spin muted' },
  running: { icon: 'spinner', text: 'Currently running', class: 'fa-spin standard-blue' },
  finished: { icon: 'check-circle', style: { color: 'green' }, text: 'Finished' },
  draft: { icon: 'pencil-square', text: 'Draft', class: 'muted' },
  failed: { icon: 'exclamation-circle', style: { color: 'red' }, text: 'Failed' },
};

export const StatusIconCell = ({ cellData, size = '2x' }) => {
  const icon = iconSet[cellData];

  return (
    <Icon
      name={icon.icon}
      style={icon.style}
      size={size}
      className={icon.class}
    />
  );
};

StatusIconCell.propTypes = {
  cellData: PropTypes.string,
  size: PropTypes.string,
};

export const StatusIconHeader = ({ status }) => {
  const icon = iconSet[status];
  return (
    <div>
      <Icon name={icon.icon} style={icon.style} size='lg' /> {icon.text}
    </div>
  );
};

StatusIconHeader.propTypes = {
  status: PropTypes.string,
};
